import { useEffect } from "react";
import Header from "@/components/Header";
import LegalBanner from "@/components/LegalBanner";
import Footer from "@/components/Footer";
import { Seo } from "@/lib/seo";

export default function About() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-white text-stone-900 font-sans antialiased" data-testid="about-page">
      <Seo
        title="About DriveClear — Underwriting clarity for car buyers"
        description="DriveClear gives everyday car buyers the underwriting-style clarity lenders have always had — transparency that builds confidence and improves the car buying process for everyone."
        path="/about"
      />
      <LegalBanner />
      <Header />
      <main className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight mb-6">About DriveClear</h1>
          <div className="space-y-6 text-stone-600 text-base leading-relaxed">
            <p>
              Most people walk into a dealership knowing the sticker price and almost nothing else. Lenders, meanwhile, evaluate every deal with precise guidelines — debt-to-income limits, loan-to-value ceilings, risk tiers — that buyers never get to see.
            </p>
            <p>
              DriveClear exists to close that gap. It provides transparency and underwriting-style language to consumers who may not know where they align. It builds confidence and improves the car buying process for everyone.
            </p>
            <p>
              This website offers free calculators and the real DriveClear Fit score — the same engine the app uses. The DriveClear app goes further: it explains what's helping your score, what to watch, the underwriter's view of your deal, and the specific moves that bring the car you want within reach.
            </p>
            <p className="text-sm text-stone-500 border-l-2 border-stone-200 pl-4">
              DriveClear is an independent consumer education tool. It is not a bank, lender, loan broker, or credit repair organization, and nothing it produces is a credit offer or lending decision.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
